import { Link } from 'react-router-dom';

export default function Navbar() {
    return (
        <nav>
            <div className='link-container'>
                <Link to="/">{<i className="fa-sharp fa-solid fa-house"></i>}</Link>
                <Link to="/explore">{<i className="fa-sharp fa-solid fa-magnifying-glass"></i>}</Link>
                <Link to="/favorites">{<i className="fa-star fa-solid"/>}</Link>
                <Link to="/login">{<i className="fa-regular fa-user user-login"></i>}</Link>
            </div>
        </nav>
    )
}

